<tyt-offers-wizard 
    class="theme-{{theme}}"
    [offerSet]="offers.offerSet" 
    [step]="offers.step" 
    [offerUUID]="offers.offerUUID" 
    [price]="offers.price" 
    [period]="offers.period" 
    [offer]="offers.offer" 
    [previewing]="offers.previewing"
    [showAttentionBanner]="false"
    [inSettings]="false"
    [knownEmail]="offers.knownEmail"
    [knownFirstName]="offers.knownFirstName"
    [showNoThanks]="offers.showNoThanks"></tyt-offers-wizard>